export default "__VITE_ASSET__CYVlMLf5__"